import { gql } from 'graphql-request'

export namespace TaskManager {
  export function updateTaskManager() {
    return gql`
      mutation updateTaskManager($id: Int!, $taskManager: TaskManagerMutation) {
        updateTaskManager(id: $id, taskManager: $taskManager) {
          id
          dueDate
          startTime
          endTime
        }
      }
    `
  }
}
